import * as React from "react";
import { Menu, MenuItem } from "@mui/material";
import { Button } from "@mui/material";
import { useState } from "react";
import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import ExportButton from "../../../Reporting/ExportButton";
import styles from "./SelectLists.module.scss";
import { styled } from "@mui/system";

type PickedStates = {
  label?: string;
  value?: string;
};

interface ExportDropDownProps extends PickedStates {
  csvData: string[][];
  data: string[][];
  pickedStates?: PickedStates[];
}

const MenuDialog = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    marginTop: theme.spacing(4),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
}));

const ExportDropDown = (props: ExportDropDownProps): JSX.Element => {
  const { csvData, data, pickedStates } = props;
  // Make disclaimer row match the number of columns in the CSV data
  const columnCount = csvData && csvData[0] ? csvData[0].length : 1;
  const titleRow = [
    `Opus Export - ${new Date().toLocaleDateString()} | DISCLAIMER: This material is intended as a guide to various state requirements. Please refer to the referenced statutes for additional information and contact the legal department with further questions, or if you need clarification.`,
    ...Array(columnCount - 1).fill(""),
  ];
  // Prepend combined title/disclaimer row to CSV data
  const csvDataWithDisclaimer = [titleRow, ...csvData];
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button onClick={handleClick} className={styles.Button}>
        Export
        <KeyboardArrowDownRounded />
      </Button>
      <MenuDialog
        elevation={0}
        className={styles.Menu}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem className={styles.MenuItem}>
          <CSVLink
            data={csvDataWithDisclaimer}
            filename="opus-export.csv"
            className={styles.CSV}
          >
            CSV
          </CSVLink>
        </MenuItem>
        {/* PDF */}
        <MenuItem className={styles.MenuItem}>
          <ExportButton data={data} pickedStates={pickedStates} />
        </MenuItem>
      </MenuDialog>
    </div>
  );
};

export default ExportDropDown;
